module.exports = __webpack_public_path__ + "static/img/img_lease_successful.cb654d44.png";